export { default } from './NearbyBuoysHeader';
